module.exports = __webpack_public_path__ + "static/digital-periodic-maintenance-a7e9314f1e1808b0a97cc0e89169a0ef.jpg";